const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
  recoverButton: '[js-customer-account="recover"]',
  loginButton: '[js-customer-account="login"]',
  recoverText: '[js-customer-account="recover-text"]',
  recoverForm: '[js-customer-account="recover-form"]',
  loginText: '[js-customer-account="login-text"]',
  loginForm: '[js-customer-account="login-form"]',
  addNewAddress: '[js-addresses="add-new-button"]',
  newAddressForm: '[js-addresses="add-new"]',
  cancelButton: '[js-addresses="cancel"]',
  editFormButton: '[js-address="edit-form-button"]',
  editForm: '[js-address="edit-form"]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
        container,
        addressContainer: container.querySelector(selectors.addressContainer),
        toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
        cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
        deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
        countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        addNewAddress: container.querySelector(selectors.addNewAddress),
        newAddressForm: container.querySelector(selectors.newAddressForm),
        cancelButton: container.querySelector(selectors.cancelButton),
        editFormButton: container.querySelectorAll(selectors.editFormButton),
      }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });

      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
    this.elements.addNewAddress.addEventListener('click', () => {
      this.elements.newAddressForm.classList.remove('hidden');
    });
    this.elements.cancelButton.addEventListener('click', () => {
      if (this.elements.newAddressForm.classList.contains('hidden')) {
        return;
      }

      this.elements.newAddressForm.classList.add('hidden');
    });
    this.elements.editFormButton.forEach((button) => {
      button.addEventListener('click', this._handleEditForm);
    });
  }

  _toggleExpanded(target) {
    if (!target) {
      return;
    }

    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).classList.add('hidden'));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };

  _handleEditForm({ currentTarget }) {
    const buttonId = currentTarget.dataset.addressId;
    const editForms = document.querySelectorAll(selectors.editForm);

    editForms.forEach((element) => {
      const isTargetForm = element.id === buttonId;
      element.classList.toggle('hidden', !isTargetForm);

      if (isTargetForm) {
        const inputs = element.querySelectorAll('input');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].type !== 'hidden' && inputs[i].style.display !== 'none') {
            inputs[i].focus();
            break;
          }
        }
      }
    });
  }
}

class CustomerLogin {
  constructor() {
    this._setupEventListeners();
  }

  _setupEventListeners() {
    document.querySelector(selectors.recoverButton).addEventListener('click', () => {
      document.querySelector(selectors.recoverText).classList.remove('hidden');
      document.querySelector(selectors.loginText).classList.add('hidden');
      document.querySelector(selectors.recoverForm).classList.remove('hidden');
      document.querySelector(selectors.loginForm).classList.add('hidden');
    });

    document.querySelector(selectors.loginButton).addEventListener('click', () => {
      document.querySelector(selectors.recoverText).classList.add('hidden');
      document.querySelector(selectors.loginText).classList.remove('hidden');
      document.querySelector(selectors.recoverForm).classList.add('hidden');
      document.querySelector(selectors.loginForm).classList.remove('hidden');
    });
  }
}
